$( document ).ready( function() {
  let controller = null;
  let scene = null;

  const scrollMagic = () => {
    if (window.matchMedia("(min-width: 901px)").matches) {
      if (controller === null) {
        // init controller
        controller = new ScrollMagic.Controller({
          globalSceneOptions: {
            triggerHook: "onEnter", duration: "250%"
          }
        });

        // build scenes
        scene = new ScrollMagic.Scene({
          triggerElement: ".js-parallax"
        })
        .setTween(".js-parallax", {
          y: "25%", ease: Linear.easeNone
        })
        .addTo(controller);
      }
    }
    else {
      if (controller !== null) {
        controller.destroy(true);
        controller = null;
        scene.destroy(true);
        scene = null;
      }
    }
  }


  if (window.matchMedia) {
    scrollMagic();
    window.addEventListener('resize', scrollMagic);
  }

});
